import { useHandleCancelableApi } from 'common/Hooks/UseHandleCancelableApi'
import { useEffect, useState } from 'react'

export const useTableState = (onChange) => {

	const DEFAULT_PAGE_SIZE = 20
	const DEFAULT_PAGE = 1

	const [keyword, setKeyword] = useState('')
	const [page, setPage] = useState(DEFAULT_PAGE)
	const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE)
	const [filters, setFilters] = useState({})
	const [isFirstTime, setIsFirstTime] = useState(true)

	const handleOnChange = (abortSignal) => {
		onChange(keyword, filters, { page, pageSize }, abortSignal)
	}

	const resetPage = () => {
		setPage(1)
	}

	const { handleApiCall } = useHandleCancelableApi(handleOnChange, null, 800, true)

	useEffect(() => {
		if (!isFirstTime) {
			handleApiCall()
		}
	}, [keyword])

	useEffect(() => {
		if (filters.productionCreateDate && filters.productionCreateDate.startDate && filters.productionCreateDate.endDate) {
			onChange(keyword, filters, { page, pageSize })
		}
		if (isFirstTime) {
			setIsFirstTime(false)
		}
	}, [page, pageSize, filters])

	return { keyword, setKeyword, page, setPage, pageSize, setPageSize, filters, setFilters }
}
